import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// node v16.17.1

import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/element/index.scss'
import './assets/element/custom.scss';
import zhTw from 'element-plus/es/locale/lang/zh-tw'


import Pagination from "./components/layouts/Pagination.vue";
import PageTitle from "./components/layouts/PageTitle.vue";
import PageHeader from "./components/layouts/PageHeader.vue";



const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.component("Pagination", Pagination);
app.component("PageTitle", PageTitle);
app.component("PageHeader", PageHeader);

app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: zhTw,
})

app.mount('#app')